import { useTranslation } from 'react-i18next'
import ReorderPage from '../components/ReorderPage'

const NewsReorder = () => {
    const { t } = useTranslation()

    return (
        <div className='min-h-screen bg-gray-100'>
            <ReorderPage
                fetchEndpoint='/admin/news'
                reorderEndpoint='/admin/news/reorder'
                title={t('reorder.reorder_appeals')}
                getItemImage={item =>
                    item.featured_image || item.image_preview || item.header_image || ''
                }
                getItemTitle={item => item.title || item.name}
                successEndpoint='/admin/auth/news'
            />
        </div>
    )
}

export default NewsReorder
